import React from 'react';

import { RadioGroup, RadioGroupProps } from '../RadioButton/RadioGroup';

type YesNoRadioProps = Omit<RadioGroupProps<boolean>, 'options'>;

export const YesNoRadio = (props: YesNoRadioProps) => (
  <RadioGroup
    options={[
      { id: true, name: 'Yes' },
      { id: false, name: 'No' },
    ]}
    {...props}
  />
);
